export const POI_ACTIONS = {
  TOGGLE_SHOW_ZONES: "TOGGLE_SHOW_ZONES",
  TOGGLE_SHOW_POINTS: "TOGGLE_SHOW_POINTS",
  TOGGLE_SHOW_ROUTES: "TOGGLE_SHOW_ROUTES",
  TOGGLE_ALL_POIS: "TOGGLE_ALL_POIS",
  SET_ZONES: "SET_ZONES",
  SET_POINTS: "SET_POINTS",
  SET_ROUTES: "SET_ROUTES",
};
